import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchFilterComponent from "../../../Common/SearchFilterComponent/SearchFilterComponent";
import { Dropdown, Spinner } from "react-bootstrap";
import ImageLoader from "../../../Common/ImageLoader";
import { HGHighlightText } from "../../../App/App";
import ThreeDotsIcon from "../../../icons/three-dots.icon";


const ProductsTab = ({ products = [], redirectAreaPath, isLoading }) => {
  const navigate = useNavigate();
  const searchRef = useRef(null);
  const [search, setSearch] = useState('');

  const filteredProducts = products.filter((product) => {
    return product.ProductName.toLowerCase().includes(search.toLowerCase());
  });

  const rederictToProductArea = () => {
    navigate(redirectAreaPath);
  }

  return (
    <div className="storefront-tab">
      <SearchFilterComponent
        passedRef={searchRef}
        leftSide={(
          <div className="d-flex align-items-center gap-8">
            <div className="f-14 line-height-22 f-600 f-black">
              Products in category
            </div>
            {isLoading && (
              <Spinner
                animation="border"
                variant="secondary"
                size="sm"
                style={{
                  width: '16px',
                  height: '16px',
                }}
              />
            )}
          </div>
        )}
        searchValue={search}
        searchOnChange={(e) => {
          setSearch(e.target.value);
        }}
        searchOnCross={() => setSearch('')}
        setRef={(ref) => {
          searchRef.current?.focus();
        }}
        lastButtonOnClick={() => {
          rederictToProductArea();
        }}
      />
      <div className="products-list">
        {!filteredProducts?.length ? (
          <div className="d-flex justify-content-center align-items-center h-100">
            <div className="f-14 line-height-22 f-600 f-black">
              No products found
            </div>
          </div>
        ) : (
          filteredProducts.map((product) => (
            <ProductItem 
              key={product.ProductId} 
              product={{
                ...product,
                productIcon: product.ProductIcon,
                productName: product.ProductName,
                category: product.CategoryName,
                subcategory: product.SubCategoryName,
              }}
              search={search}
              onActionClick={() => {
                rederictToProductArea();
              }}
            />
          ))
        )}
      </div>
    </div>
  )
}

export default ProductsTab;

const actions = [
  {
    label: 'Edit',
    icon: 'edit',
    onClick: () => {}
  },
  {
    label: 'Delete',
    icon: 'delete',
    onClick: () => {},
    className: 'f-red'
  }
]

const ProductItem = ({ product, search, onActionClick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const categoryTitle = `${product.category} ${product.subcategory ? ` > ${product.subcategory}` : ''}`
  return (
    <div className="product-item parent-hovering" key={product.id}>
      <div className="d-flex align-items-center gap-8">
        <ImageLoader
          src={product.productIcon}
          alt={product.productName}
          width={24}
          height={24}
          noImageComponent={(
            <img src={'/images/settings-nav/product_icon.svg'} alt={product.productName} width={24} height={24} />
          )}
        />
        <div>
          <h3 className="m-0 f-14 line-height-22 f-black f-500">
            <span
              dangerouslySetInnerHTML={{
                __html: HGHighlightText(product.productName, search)
              }}
            />
          </h3>
          <p className="m-0 f-12 line-height-18 f-darkgrey f-400">{categoryTitle}</p>
        </div>
      </div>
      <div className={`visible-child ${isOpen ? 'show' : ''}`}>
        <Dropdown
          className="transparennt-wrapper-dropdown my-dropdown my-dropdown-common"
          onToggle={(open) => setIsOpen(open)}
        >
          <Dropdown.Toggle>
            <ThreeDotsIcon />
          </Dropdown.Toggle>
          <Dropdown.Menu className="menu">
            {actions.map((action) => (
              <div key={action.label} onClick={() => {
                action.onClick();
                onActionClick();
              }} className={`item ${action.className}`}>
                {action.label}
              </div>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  )
}
